export enum AmplitudeEvent {
    // SHARED EVENTS
    EXPORTED_REPORT = "Exported Report",

    // FRONTEND EVENTS
    RAN_REPORT = "Ran Report",
    SAVED_REPORT = "Saved Report",
    RAN_CHECK_BULK = "Ran Check (Bulk)",
    SCAN_FROM_BULK_INSIGHTS = "Scan From Bulk Insights",
    UPLOADED_CSV = "Uploaded CSV",
    LOGGED_IN = "Logged In",
    ENCOUNTERED_ERROR_FE = "Encountered Error (FE)",
    VIEWED_POLICY = "Viewed Policy",
    CREATED_OVERRIDE = "Created Override",
    UPDATED_OVERRIDE = "Updated Override",
    DELETED_OVERRIDE = "Deleted Override",
    FAKE_DOOR_SHOWN = "Fake Door Shown",
    FAKE_DOOR_CLICKED = "Fake Door Clicked",
    POLICY_ASSIGNMENT_PAGE_VIEWED = "Policy Assignment Page Viewed",
    MANAGE_GROUPS_PAGE_VIEWED = "Manage Groups Page Viewed",
    ASSIGNED_POLICIES_PAGE_VIEWED = "Assigned Policies Page Viewed",
    POLICY_CHANGE_STATUS_BULK = "Change Policy Status - bulk",
    POLICY_CHANGE_STATUS_SINGLE = "Change Policy Status - single",
    POLICY_CHANGE_PRIORITY_BULK = "Change Policy Priority - bulk",
    POLICY_CHANGE_PRIORITY_SINGLE = "Change Policy Priority - single",
    POLICY_REASSIGN_BULK = "Reassign Policy - bulk",
    POLICY_REASSIGN_SINGLE = "Reassign Policy - single",
    POLICY_ASSIGN_BULK = "Assign Policy - bulk",
    POLICY_ASSIGN_SINGLE = "Assign Policy - single",
    EHR_WRITE_BUTTON_CLICKED = "Write to EHR Button Clicked",
    EHR_WRITE_MODAL_CONFIRMED = "Write to EHR Modal Confirmed",
    EHR_WRITE_MODAL_CANCELED = "Write to EHR Modal Canceled",
    RE_CHECK_PATIENT_ID_ADDED = "Re-check Patient ID Added",
    RE_CHECK_PATIENT_ID_UPDATED = "Re-check Patient ID Updated",
    RE_CHECK_PATIENT_ID_NO_CHANGE = "Re-check Patient ID No Change",
    RE_CHECK_MODAL_CANCELED = "Re-check Modal Canceled",

    // BACKEND EVENTS
    RAN_CHECK_SINGLE = "Ran Check (Single)",
    SIGNED_UP = "Signed Up",
    HARD_QUOTA_REACHED = "Hard Quota Reached",
    SOFT_QUOTA_REACHED = "Soft Quota Reached",
    ENCOUNTERED_ERROR_BE = "Encountered Error (BE)",
    CREATE_GROUP = "Create Group",
    EDIT_GROUP = "Edit Group",
    DELETE_GROUP = "Delete Group",
    EHR_WRITE_SUCCESS = "Write to EHR Success",
    EHR_WRITE_FAILURE = "Write to EHR Failure",
    EHR_WRITE_CREATED = "Write to EHR Insurance Created",
    EHR_WRITE_ELIGIBILITY_STARTED = "Write to EHR Eligibility Started",
    EHR_WRITE_ELIGIBILITY_COMPLETED = "Write to EHR Eligibility Completed",
    CREATE_NETWORK_STATUS_RULES_VERSION = "Create Network Status Rules Version",
    DEMO_LOGIN = "Demo Login",
}

export const COMMON_AMPLITUDE_CONFIG = {
    amplitudeDeviceIdHeader: "nirvana-amplitude-device-id",

    amplitudeUserIdPrefix: "user_",
}
